import { ElementSize } from '../../../../types';
import { cn } from '../../../../utils/styles';
import { InputClassNames } from '../../constants';

import { InputErrorRoot } from './InputError.styled';

/**
 * In case error space is reserved we show span with aria-hidden="true" + visibility:hidden,
 * however in order to make sure space takes exact same height as actual error message we render some placeholder text as child
 */
const PLACEHOLDER = '_';

type Props = React.HTMLAttributes<HTMLSpanElement> & {
  elementSize: ElementSize;
  error: string | undefined;
  isErrorHidden: boolean | undefined;
  isErrorSpaceReserved: boolean | undefined;
  inputTestId: string | undefined;
};

const InputError: React.FC<Props> = props => {
  const {
    className,
    elementSize,
    error,
    isErrorHidden,
    isErrorSpaceReserved,
    inputTestId,
    ...rest
  } = props;

  const hasError = !!error;

  if ((!hasError && !isErrorSpaceReserved) || isErrorHidden) return null;

  return (
    <InputErrorRoot
      $size={elementSize}
      aria-hidden={!hasError}
      className={cn(InputClassNames.Error, className)}
      data-testid={inputTestId ? `${inputTestId}-error` : undefined}
      {...rest}>
      {error || PLACEHOLDER}
    </InputErrorRoot>
  );
};

export default InputError;
